module.exports = __webpack_public_path__ + "img/custom.48dfe958.svg";